import { createReducer } from '@reduxjs/toolkit';
import {
    SET_SUBMITTING_CONTACT, UNSET_SUBMITTING_CONTACT, SET_SUBMITTED_CONTACT,
} from '../actions/ContactAction';

const initialState = {
    submitting: false,
    submitted: false,
};

const contact = createReducer(initialState, (builder) => {
    builder
        .addCase(SET_SUBMITTING_CONTACT, (state) => {
            state.submitting = true;
        })
        .addCase(UNSET_SUBMITTING_CONTACT, (state) => {
            state.submitting = false;
        })
        .addCase(SET_SUBMITTED_CONTACT, (state) => {
            state.submitted = true;
        });
});

export default contact;
